const openPositions = (gsap) => {
  
  function removeDuplicates(array) {
    return array.filter((a, b) => array.indexOf(a) === b)
  };
  
  const $positionsBlock = $('.page-careers .positions-info'),
        $noJobsBlock = $('.page-careers .no-positions'),
        departments = $('.page-careers .dept-count'),
        locations = $('.page-careers .loc-count'),
        openings = $('.page-careers .pos-count'),
        deptLabel = $('.page-careers .dept-label'),
        locLabel = $('.page-careers .loc-label'),
        posLabel = $('.page-careers .pos-label'),
        numStart = {val:0},
        positions = 'https://boards-api.greenhouse.io/v1/boards/videoamp/jobs?content=true'; // API link for all jobs

  if ($positionsBlock.length) {
    
    $.ajax({
      url: positions,
      type: 'GET',
      success: function(data) {

        const jobCount = data.meta.total,
              jobs = data.jobs,
              depts = [],
              locs = [];

        if ( jobCount > 0 ) {

          $positionsBlock.fadeIn();
          $noJobsBlock.hide();

          $.each(jobs, function(key,value) {

            const eachDept = value.departments;

            $.each(eachDept, function(i, item) {
              depts.push(item.name);
            });

            locs.push(value.location.name);

          });

          const deptCount = removeDuplicates(depts).length,
              locCount = removeDuplicates(locs).length;

          if (deptCount == 1) {
            deptLabel.text('Department');
          }

          if (locCount == 1) {
            locLabel.text('Location');
          }

          if (jobCount == 1) {
            posLabel.text('Position');
          }
          
          departments.html(deptCount);
          locations.html(locCount);
          openings.html(jobCount);

        } else {
          $positionsBlock.hide();
          $noJobsBlock.fadeIn();
        }

      }

    });
    
  }
  
}

export {
  openPositions
};
